enum CrudActionType {
  CLONE = 'clone',
  CREATE = 'create',
  EDIT = 'edit',
}

export default CrudActionType;
